<template>
  <div>
    <vue-order-details :order="order" :reference="$route.params.reference" />
    <br />
    <div class="row align-items-end">
      <!-- <div v-if="orderItem.id" class="row align-items-end"> -->
      <!-- <div class="col-xl-3 col-12">
        <label for="">Catégorie</label>
        <vue-select :options="sections" v-model="section_reference" placeholder="Select an option"
          labelColumn="fullName" valueColumn="reference" />
      </div> -->

      <div class="col-xl-3 col-12">
        <label for="">Produit</label>

        <vue-select :options="filteredItems" v-model="orderItem.item_reference" placeholder="Select an option"
          labelColumn="fullName" valueColumn="reference" />

 
      </div>

      <div class="col-xl-2 col-12" v-if="$userRole != 'Magasinier'">
        <label for="">Prix U </label>
        <input type="text" v-show="$userRole !== 'Magasinier'" v-model="orderItem.priceTTC" class="form-control" />
      </div>

      <div class="col-xl-2 col-12">
        <label for=""> Quantité </label>
        <input type="text" v-model="orderItem.quantity" class="form-control" />
      </div>

      <div class="col-xl-auto col">
        <label for=""></label>
        <button class="btn btn-success" @click="save(orderItem)">
          <i class="bi bi-plus-circle"></i> Enregistrer
        </button>
      </div>

      <div class="col-xl-auto col-auto">
        <button class="btn btn-secondary d-flex align-items-center" @click="refresh()">
          <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
          <span> Actualiser </span>
        </button>
      </div>
    </div>
    <br />

    <vue-data-table v-if="order.orderItems" :headers="headers" :data="order.orderItems" :items-per-page="10"
      :buttons="buttons" :summable-columns="summableColumns">

      <template #cell-priceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.priceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.priceTTC }}
        </span>
      </template>


      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded " v-show="$userRole != 'Magasinier'"
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

    </vue-data-table>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12">

      </div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="validated()">
          <i class="bi bi-arrow-right-circle"></i> Suivant
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import order from "../../../../store/modules/order";

export default {
  data() {
    return {
      orderItem: {
        id: "",
        item_reference: "",
        order_reference: "",
        quantity: "",
        priceTTC: ""
      },
      section_reference: "",
      accept: false,
      // Table headers configuration
      headers: [
        { field: 'itemFullName', label: 'Désignation', class: '' },
        { field: 'priceTTC', label: 'Prix', class: 'fw-bold' },
        { field: 'quantity', label: 'Quantité', class: 'fw-bold' },
        { field: 'totalPriceTTC', label: ' Total ', class: 'fw-bold' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      // Button actions
      buttons: [
        {
          label: 'Modifier',
          icon: 'bi bi-pencil',
          class: 'btn btn-warning',
          action: (item) => {
            this.editItem(item);
          },
        },
        {
          label: 'Supprimer',
          icon: 'bi bi-trash',
          class: 'btn btn-danger',
          action: (item) => {
            this.deleteItem(item);
          },
        },
      ],
      // Columns to summarize
      summableColumns: [
        // { field: 'totalPriceTTC', class: 'tfw-bold' },
        { field: 'quantity', class: 'fw-bold' },
      ],

    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("section", {
      sections: "getAll",
    }),

    ...mapGetters("order", {
      order: "getOrder",
    }),

    filteredItems() {
      if (this.section_reference == "") {
        return this.items;
      }

      return this.items.filter(
        (item) => item.section_reference == this.section_reference
      );
    },
  },
  methods: {
    async save(data) {
      if (data.id === "") {

        await (data.order_reference = this.order.reference);

        await this.$store.dispatch("order/storeItem", data);

        await (this.orderItem = {
          id: "",
          item_reference: "",
          order_reference: "",
          quantity: "",
          priceTTC: ""
        });
        
        await this.$store.dispatch("order/show", this.$route.params.reference);

      }
      else {

        await (data.order_reference = this.order.reference);

        await this.$store.dispatch("order/updateItem", data);
        await (this.orderItem = {
          id: "",
          item_reference: "",
          order_reference: "",
          quantity: "",
          priceTTC: ""
        });
      }
    },

    async refresh() {
      await this.$store.dispatch("section/getAll");
      await this.$store.dispatch("item/getAll");
      await this.$store.dispatch("order/show", this.$route.params.reference);
    },
    async validated() {
      this.$router.push({
        name: "orders-edit", params: {
          reference: this.$route.params.reference
        }
      });
    },

    async editItem(item) {
      await (this.orderItem.id = item.id)
      await (this.orderItem.item_reference = item.reference)
      await (this.orderItem.quantity = item.quantity)
      await (this.orderItem.priceTTC = item.priceTTC)
      // Add your editing logic here
    },
    async deleteItem(item) {
      await this.$store.dispatch("order/destroyItem", item.id);
    },
  },
  async mounted() {
    await this.$store.dispatch("section/getAll");
    await this.$store.dispatch("item/getAll");
    await this.$store.dispatch("order/show", this.$route.params.reference);
  },
};
</script>
<style scoped></style>